import React from 'react';
import { Offer } from '../../typing/offer';
import { StyledTrimModuleOfferCard } from './styles';
import TrimModuleOfferType from '../trim-module-offer-type';
import {
  DisableFocusWrapper,
  LinkButton,
  TextCustom,
} from '@ngw6/us-components';
import { TrimModuleOfferCardTranslations } from '../../typing/translations';
import {
  getPrettyOfferLocale,
  offerCardLegalStyle,
  offerCardLocaleStyle,
  offerCardTitleStyle,
  offerViewDetailsStyle,
} from './helpers';

interface TrimModuleOfferCardProps {
  offer: Offer;
  translation: TrimModuleOfferCardTranslations;
  onViewDetails: (offer: Offer) => void;
}
const TrimModuleOfferCard: React.FC<TrimModuleOfferCardProps> = (props) => {
  const { offer, translation, onViewDetails } = props;
  const offerLocaleText = getPrettyOfferLocale(
    offer.localeType,
    offer.dealEndDate,
    translation.offerLocale,
  );
  const offerType = offer.dealOfferTypes.length
    ? offer.dealOfferTypes[0]
    : undefined;
  return (
    <StyledTrimModuleOfferCard>
      <TrimModuleOfferType offerType={offerType} />
      <div className="offer-title">
        <TextCustom {...offerCardTitleStyle}>{offer.offerTitle}</TextCustom>
      </div>
      <div className="offer-subtitle">
        <TextCustom {...offerCardLegalStyle}>{offer.offerSubtitle}</TextCustom>
      </div>
      <div className="offer-locale-type">
        <TextCustom {...offerCardLocaleStyle}>{offerLocaleText}</TextCustom>
      </div>
      <div className="offer-view-details">
        <DisableFocusWrapper>
          <LinkButton isInline onClick={onViewDetails.bind(null, offer)}>
            <TextCustom {...offerViewDetailsStyle}>
              {translation.viewDetailsCta}
            </TextCustom>
          </LinkButton>
        </DisableFocusWrapper>
      </div>
    </StyledTrimModuleOfferCard>
  );
};

export default TrimModuleOfferCard;
